module.exports = __webpack_public_path__ + "img/plus.df08dfb5.svg";